<template>
	<!-- 新建分组-->
	<div>
		<el-dialog width="630px" :title="title" :visible.sync="studentEditDialogVisible" center
			:before-close="closeDialog" :close-on-click-modal="false">

			<el-form :model="forDataInfo" @submit.native.prevent class='update-form' size="small" ref="formLabel">
				<el-form-item prop="name" :rules="[
							  { required: true, message: '请输入分组名称', trigger: 'change' },
							]">
					<el-input class="group-name-color" v-model="forDataInfo.name" clearable placeholder="请输入分组名称"
						maxlength="15" show-word-limit>
					</el-input>
				</el-form-item>
				<el-form-item label="请选择下列附件到分组中">
				</el-form-item>
				<el-form-item>
					<div class="file-list" :class="{ 'file-group-hover-background': item.hover }"
						v-for="(item, index) in course_files">

						<div class="file-list-item">
							<el-checkbox v-model="item.select" :disabled="item.disabled" class="checkbox-center">
								<div class="list-title">
									<div>
										<img :src="util.setFileIcon(item.url)">
									</div>
									<div>
										<span>{{ item.name.length > 40 ? item.name.substring(0, 40) + '...' : item.name }}({{ item.size }})</span>
									</div>

								</div>
							</el-checkbox>
						</div>

					</div>

				</el-form-item>

			</el-form>
			<span slot="footer" class="dialog-footer">
				<button class="cancel-btn mr-10" type="button" @click="closeDialog">取消</button>
				<button class="dark-btn" :disabled="isDisabled" type="button" :loading="editloading"
					@click="updateSure('formLabel')">保存
				</button>
			</span>
		</el-dialog>
	</div>

</template>

<script>
	export default {
		components: {},
		data() {
			return {
				studentEditDialogVisible: false,
				selectedList: [],
				editloading: false,
				isDisabled: false,
				title: "新建分组",
				userphone: "",
				forDataInfo: {
					name: "",

				},
				countdown: 0,
				msg: "",
				course_files: [],
				course_files_group: [],
				dataInfo: {},
				isSave: false,


			}
		},
		computed: {

		},
		methods: {
			//确定分组
			updateSure() {
				this.$refs['formLabel'].validate((valid) => {
					if (valid) {
						if (this.forDataInfo.name.length>15) {
							this.$message({
								message: "分组名称不能大于15个字符",
								type: 'error'
							});
							return
						}

						let isShowGroupName = false
						this.course_files_group.forEach(item => {
							if (item.group.name == this.forDataInfo.name) {
								isShowGroupName = true
							}
						})
						if (isShowGroupName) {
							this.$message({
								message: "组名已存在，请重新输入分组名称",
								type: 'error'
							});
							return
						}
						let selectList = []; //这次勾选的数据
						this.course_files.forEach(item => {
							if (item.select && !item.disabled) {
								selectList.push(item)
							}
						})
						if (selectList.length == 0) {
							this.$message({
								message: "请勾选分组数据",
								type: 'error'
							});
							return
						}


						this.$emit('refreshData', this.forDataInfo);
						this.isSave = true;
						this.hide();

					} else {
						return false;
					}
				});

			},
			show(data, course_files, course_files_group) {
				this.forDataInfo.name = ""
				this.studentEditDialogVisible = true;
				this.editloading = false
				this.course_files = course_files
				this.course_files_group = course_files_group
				this.dataInfo = data



				this.course_files_group.forEach(item => {
					if (item.group.name == '未分组') {
						item.list.forEach(data => {
							this.$set(data, 'select', false)
							this.$set(data, 'disabled', false)
							this.course_files.forEach(nitem => {
								if ((data.id && data.id == nitem.id) || (data.uid && data.uid ==
										nitem.uid)) {
									this.$set(nitem, 'select', false)
									this.$set(nitem, 'disabled', false)
								}
							});


						})

					} else {
						item.list.forEach(data => {
							this.$set(data, 'select', true)
							this.$set(data, 'disabled', true)
							this.course_files.forEach(nitem => {
								if ((data.id && data.id == nitem.id) || (data.uid && data.uid ==
										nitem.uid)) {
									this.$set(nitem, 'select', true)
									this.$set(nitem, 'disabled', true)
								}
							});


						})

					}
				})


				this.course_files.forEach(item => {
					if ((data.id && data.id == item.id) || (data.uid && data.uid == item.uid)) {
						this.$set(item, 'select', true)
						console.log("选中")
					}
				});





				// this.course_files.forEach(item => {
				// 	item.select = false;
				// });


			},
			//关闭后重置当前数据
			closeDialog() {
				this.course_files.forEach(item => {
					if (this.dataInfo.id && this.dataInfo.id == item.id) {
						this.$set(item, 'select', false)
						// item.disabled = false;
					} else if (this.dataInfo.uid && this.dataInfo.uid == item.uid) {
						this.$set(item, 'select', false)
						// item.disabled = false;
					}

				});


				// this.course_files.forEach(item => {
				// 	if (this.dataInfo.id && this.dataInfo.id == item.id) {
				// 		item.select = false;
				// 		item.disabled=false;
				// 	} else if (this.dataInfo.uid && this.dataInfo.uid == item.uid) {
				// 		item.select = false;
				// 		item.disabled=false;
				// 	}
				// });
				// this.course_files_group.forEach(item => {
				// 	if (item.group.name == '未分组') {
				// 		item.list.forEach(data => {
				// 			if (this.dataInfo.id && this.dataInfo.id == data.id) {
				// 				item.select = false;
				// 				item.disabled=false;
				// 			} else if (this.dataInfo.uid && this.dataInfo.uid == item.uid) {
				// 				item.select = false;
				// 				item.disabled=false;
				// 			}
				// 		})
				// 	}
				// })

				this.hide()

			},
			hide() {
				this.studentEditDialogVisible = false;
			},
		},
		mounted() {


		},

	}
</script>

<style lang="scss" scoped>
	.title {
		font-weight: 400;
	}

	.el-table::before {
		//去掉最下面的那一条线
		height: 0px;
	}

	.group-name-color {
		color: #E5E5E5FF;
	}

	.file-group-hover-background {
		background-color: #F7F7F7;
	}

	.file-list:hover {
		background-color: #F7F7F7;
	}

	.file-list-item {
		// line-height: 46px;
		padding: 9px;

		.checkbox-center {
			// width: 100%;
			// background-color: aqua;
		}

		.list-title {
			display: flex;
			align-items: center;
			justify-content: flex-start;
			width: 550px;
			border-bottom: 1px solid #E5E5E5;
			padding-bottom: 5px;

			div:nth-of-type(2) {
				margin-left: 10px;
			}

			img {
				height: 20px;
			}
		}
	}

	// .file-list-item>div:nth-of-type(2) {
	// 	width: 100%;
	// 	// margin-left: 10px;
	// }


	.checkbox-center /deep/ .el-checkbox__input {
		// padding-bottom: 10px;

	}

	.comment-flex-start {}
</style>